module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 case-box",
    class: _vm.shortname
  }, [_c('div', {
    staticClass: "headline",
    class: _vm.position
  }, [_c('b', [_vm._v(_vm._s(_vm.name))]), _c('br'), _vm._v("\n        " + _vm._s(_vm.type) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "inside-overlay"
  }, [_vm._v("\n            Læs mere om vores løsning til "), _c('b', [_vm._v(_vm._s(_vm.name))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3230207e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/case/components/case.vue
// module id = 308
// module chunks = 1